<template>
  <BaseTemplate>
    <Login class="login" />
  </BaseTemplate>
</template>

<script>
import Login from '@/components/pages/UserLogin/Login.vue';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';

export default {
  components: {
    Login,
    BaseTemplate,
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding-top: 100px;
}
</style>
